import React from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import Input from "components/input/input";
import toast from "react-hot-toast";

export default function UserDeleteModal({ hide, user={}, ...props }) {
  const { http } = global.services;

  const [state,setState] = React.useState({
    password:null,
    showPassword:false
  });
  const [loading,setSubmitLoading] = React.useState(false);

  const Footer = () => {
    return (
      <div className="relative flex flex-row items-center justify-end space-x-2">
        <Button
          buttonName="Cancel"
          buttonClass="bg-thBg py-3 px-9"
          buttonTextClass="text-black text-sm font-bold"
          onClick={() => hide()}
          disabled={loading}
        />
        <Button
          key="block-btn"
          buttonName="Continue"
          buttonClass="bg-lightBlack py-3 px-12"
          buttonTextClass="text-white text-sm font-bold"
          onClick={confirmDelete}
          disabled={loading}

        />
      </div>
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
    ...prev,
    [name]: value,
    validationErrors: { ...state.validationErrors, [name]: null },
    }));
};

const confirmDelete = async()=>{
        try {
            setSubmitLoading(true);
            const { data } = await http.delete(`admin-delete/${user?.user?.id}`,{
                password:state.password,
                user_id_delete: user?.user?.id
            });
            toast.success('Successfully Deleted')
            hide({ message:data?.message, success: true });
          } catch (err) {
            console.log("error@delete", err);
            toast.error('Something went wrong')
            const {data} = err;
            setSubmitLoading(false);
            setState((prev) => ({
            ...prev,
            validationErrors: { ...state.validationErrors, password: data?.error || (data?.errors?.password ? data?.errors?.password[0] : null) },
            }));
          } finally {
            setSubmitLoading(false);
          }
    }

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-12/20 2md:w-10/20 3md:w-7/20 1xl:w-5/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-mutedGray"
    >
      <div className="w-full">
        {/* header */}
        <ModalHeader title="Delete User" hide={hide} />
        {/* content */}
        <div className="pl-10 pr-7 py-7">
          <p className="text-lightBlack pb-2">
            Are you sure you want to delete this account
            <strong> {user?.user?.first_name} {user?.user?.last_name} ({user?.user?.email}) </strong>
          </p>
          <lable className="pt-4">Please type <strong>'DELETE'</strong> to confirm</lable>
          <Input
            required
            inputContainerClass="form-input-container"
            value={state.password}
            // outsideLabel="Please type 'DELETE' to confirm"
            outsideLabelClass="text-xs 1xs:text-sm font-bold text-darkerGray"
            noLabelPaddingY="1rem"
            name="password"
            masked={true}
            visible={state.showPassword}
            onChangeVisible={() =>
            setState((prev) => ({
                ...prev,
                showPassword: !prev.showPassword,
            }))
            }
            type={"text"}
            onChange={handleInputChange}
            errorMessage={state.validationErrors?.password}
            />
        </div>
      </div>
    </Modal>
  );
}
